import {
  Button,
  Center,
  Text,
  VStack,
  HStack,
  Box,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Flex,
  useDisclosure,
  Alert,
  AlertIcon,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberDecrementStepper,
  NumberIncrementStepper,
  Spinner,
} from '@chakra-ui/react';
import axios from 'axios';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateInsurancePrice } from '../features/calculator/calculatorSlice';

import useUser from '../hooks/useUser';

const Insurance = ({ setCalculateButtonClicked, isMobileDevice }) => {
  const { user } = useUser();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const insurancePrice = useSelector(state => state.calculator.insurancePrice);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);

  const dispatch = useDispatch();

  const handleOpen = () => {
    onOpen();
  };

  const handleApply = async () => {
    try {
      setIsUpdateLoading(true);
      const token = await user.getIdToken();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/estimator/set_insurance_price`,
        {
          username: user.email,
          insurancePrice: insurancePrice,
        },
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );
      setCalculateButtonClicked(true);
      setUnsavedChanges(false);
      setIsUpdateLoading(false);
    } catch {
      setIsUpdateLoading(false);
    }
  };

  const handleReset = async () => {
    try {
      setIsResetLoading(true);
      const token = await user.getIdToken();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/estimator/clear_insurance_price`,
        {
          username: user.email,
        },
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );
      dispatch(updateInsurancePrice(''));
      setIsResetLoading(false);
      setCalculateButtonClicked(true);
      setUnsavedChanges(false);
    } catch {
      setIsResetLoading(false);
    }
  };

  return (
    <Box
      minW={isMobileDevice ? '90vw' : ''}
      maxW={isMobileDevice ? '' : 'sm'}
      maxH="70px"
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={isMobileDevice ? '3' : '6'}
      boxShadow="base"
      borderColor="gray.400"
      bg={'gray.200'}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      cursor={isMobileDevice ? 'pointer' : 'default'}
      onClick={isMobileDevice ? handleOpen : null}
    >
      <Flex alignItems="center">
        <Text
          fontWeight="bold"
          fontSize="l"
          mr={isMobileDevice ? '0' : '4'}
          pl="10px"
        >
          Insurance
        </Text>
        {!isMobileDevice && (
          <Button
            size="sm"
            border="1px"
            borderColor="gray.600"
            ml="15px"
            onClick={handleOpen}
          >
            Edit
          </Button>
        )}
        <Modal
          isOpen={isOpen}
          size={{ base: 'full', md: 'lg' }}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalHeader>
              <HStack justify="space-between">
                <Text>Insurance</Text>
              </HStack>
            </ModalHeader>
            <ModalBody>
              <VStack align="flex-start">
                <HStack pt="10px" spacing="50px">
                  <VStack align="flex-start">
                    <Text fontSize="sm">Insurance Price $</Text>
                    <NumberInput
                      size="sm"
                      maxWidth="200px"
                      step={1}
                      keepWithinRange={false}
                      clampValueOnBlur={false}
                      value={insurancePrice}
                      onChange={value => {
                        setUnsavedChanges(true);
                        dispatch(updateInsurancePrice(value));
                      }}
                    >
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </VStack>
                </HStack>
                {unsavedChanges && (
                  <Alert status="warning">
                    <AlertIcon />
                    <VStack align="flex-start">
                      <Text fontSize="sm">Press Apply to update estimate</Text>
                    </VStack>
                  </Alert>
                )}
                <Center></Center>
              </VStack>
            </ModalBody>
            <ModalFooter>
              <HStack width="100%" justify="space-between">
                <HStack>
                  <Button onClick={handleReset}>
                    {isResetLoading ? (
                      <Spinner
                        thickness="4px"
                        speed="1.25s"
                        size="md"
                        emptyColor="gray.200"
                        color="gray.800"
                      />
                    ) : (
                      <Text>Reset</Text>
                    )}
                  </Button>
                  <Button colorScheme="blue" onClick={handleApply}>
                    {isUpdateLoading ? (
                      <Spinner
                        thickness="4px"
                        speed="1.25s"
                        size="md"
                        emptyColor="gray.200"
                        color="gray.800"
                      />
                    ) : (
                      <Text>Apply</Text>
                    )}
                  </Button>
                </HStack>
                <Button colorScheme="red" onClick={onClose}>
                  <Text>Close</Text>
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex>
    </Box>
  );
};

export default Insurance;
